import * as SwitchPrimitive from '@radix-ui/react-switch';
import { cn } from '@shared/lib/cn';

export function Switch({
  checked,
  onCheckedChange,
  className,
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
}): JSX.Element {
  return (
    <SwitchPrimitive.Root
      checked={checked}
      onCheckedChange={onCheckedChange}
      className={cn(
        'inline-flex h-7 w-12 shrink-0 items-center rounded-full border px-0.5 transition-colors duration-fast',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600/20 focus-visible:ring-offset-2 focus-visible:ring-offset-paper',
        'data-[state=checked]:border-primary-700 data-[state=checked]:bg-primary-600',
        'data-[state=unchecked]:border-hairline-strong data-[state=unchecked]:bg-sunken',
        className,
      )}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          'block h-5.5 w-5.5 rounded-full bg-white shadow-sm transition-transform duration-fast',
          'data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0',
        )}
      />
    </SwitchPrimitive.Root>
  );
}
